import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from '../../../material.module';
import {TranslateModule} from '@ngx-translate/core';
import {
  DialogCloseButtonComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent
} from '@q9elements/ui-kit/components';
import {CustomFieldsFormComponent} from '@q9elements/ui-kit/changes/shared';
import {FilterMenuModule} from '@progress/kendo-angular-grid';
import {ChangesType} from '@q9elements/ui-kit/common';

@Component({
  selector: 'app-generate-requirements-dialog',
  templateUrl: './generate-requirements-dialog.component.html',
  styleUrls: ['./generate-requirements-dialog.component.scss'],
  standalone: true,
  imports: [
    MaterialModule,
    TranslateModule,
    DialogCloseButtonComponent,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    CustomFieldsFormComponent,
    FilterMenuModule,
    ReactiveFormsModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenerateRequirementsDialogComponent {
  public changesType = ChangesType;
  public customFieldsFormGroup = new FormGroup({});
  public generateRequirementsForm = new FormGroup({
    customFields: this.customFieldsFormGroup
  });

  private readonly dialogRef = inject(MatDialogRef<GenerateRequirementsDialogComponent>);

  public onSubmit(): void {
    if (this.generateRequirementsForm.valid) {
      this.dialogRef.close(this.customFieldsFormGroup.value);
    }
  }
}
